import React from 'react';
import PropTypes from 'prop-types';
import './HexagonalLoader.css';

/**
 * HexagonalLoader Component
 * Displays an animated hexagonal loader with optional message and progress
 */
const HexagonalLoader = ({ message, className = '', progress = null, detailMessage = null }) => {
  return (
    <div className={`hexagonal-loader-wrapper ${className}`}>
      <div className="hexagonal-loader-container">
        <div className="hexagonal-loader">
          <div className="hexagon"></div>
          <div className="hexagon"></div>
          <div className="hexagon"></div>
          <div className="hexagon"></div>
          <div className="hexagon"></div>
          <div className="hexagon"></div>
        </div>
      </div>
      {message && <p className="hexagonal-loader-message">{message}</p>}
      {progress && progress.total > 0 && (
        <div className="hexagonal-loader-progress">
          <div className="progress-bar">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${(progress.current / progress.total) * 100}%` }}
            />
          </div>
          <p className="progress-text">
            {progress.current} / {progress.total} files
          </p>
        </div>
      )}
      {detailMessage && <p className="hexagonal-loader-detail">{detailMessage}</p>}
    </div>
  );
};

HexagonalLoader.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  progress: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number
  }),
  detailMessage: PropTypes.string
};

export default HexagonalLoader;
